import { IOC } from "../../@types/actor";
import { IOC_TYPES_MAP } from "./consts";
import Name from "./Name";

type IOCType = keyof typeof IOC_TYPES_MAP;

export const ActorIOCSchema = {
  fields: [
    {
      name: "type",
      displayTitle: "Type",
      sortable: true,
      component: ({ type }: IOC) =>
        IOC_TYPES_MAP[type as IOCType] ?? type?.capitalize(),
      style: { width: "10%" }
    },
    {
      name: "value",
      displayTitle: "Name",
      sortable: true,
      component: ({ type, value }: IOC) => <Name value={value} type={type} />,
      style: { width: "90%" }
    }
  ]
};
